export const DEMO_MONTH = '2026-04';

export function isDemoModeUrl(location: Location = window.location): boolean {
  return new URLSearchParams(location.search).get('demo') === '1'
    || location.pathname.replace(/\/$/, '') === '/demo';
}

export function enterDemoMode(): void {
  window.location.href = '/?demo=1#summary';
}

export function exitDemoMode(): void {
  window.location.href = '/';
}
